var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", [
    _c(
      "div",
      {
        staticClass: "d-flex align-items-center pr-3 col-sm-2 pl-0",
        staticStyle: { "max-width": "75%" },
      },
      [
        _c(
          "a",
          {
            staticClass: "px-3 py-0 d-flex align-items-center",
            attrs: { href: "/" },
          },
          [
            _c("img", {
              staticClass: "img-sizes",
              attrs: { src: require("images/logo.svg") },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.showLinks
          ? _c("div", { staticClass: "d-flex align-items-center mr-4" }, [
              _c(
                "a",
                { staticClass: "mr-3", attrs: { href: _vm.piktomirPath } },
                [
                  _c("img", {
                    staticClass: "img-sizes",
                    attrs: {
                      src: require("../assets/images/websitesIcons/piktomir_icon.png"),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("a", { attrs: { href: _vm.mireraPath } }, [
                _c("img", {
                  staticClass: "img-sizes",
                  attrs: {
                    src: require("../assets/images/websitesIcons/mirera_icon.png"),
                  },
                }),
              ]),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-between pr-0" }, [
      _c(
        "div",
        { staticClass: "buttons-header-container" },
        [
          _c(
            "div",
            {
              staticClass: "icon-container icon-substrate ml-auto",
              class: { "mr-2": _vm.hideDropdown },
              on: { click: _vm.changeLocale },
            },
            [
              _c("img", {
                staticClass: "header-icon",
                attrs: {
                  src: require(`images/headerIcons/locales/${_vm.$i18n.locale}.svg`),
                },
              }),
            ]
          ),
          _vm._v(" "),
          !_vm.hideDropdown
            ? [
                _vm.profile
                  ? [
                      _c("div", { staticClass: "d-flex h-100" }, [
                        _vm.$route.query.redirectWebsites
                          ? _c(
                              "a",
                              {
                                staticClass: "header-link h-100",
                                on: { click: _vm.redirectWebsites },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "icon-container icon-substrate",
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "header-icon",
                                      attrs: {
                                        src: require("images/headerIcons/home.svg"),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center align-items-center mx-0 h-100",
                          },
                          [
                            _c(
                              "b-dropdown",
                              {
                                staticClass:
                                  "dropdown-bg h-100 d-flex align-items-center justify-content-end h-100",
                                attrs: {
                                  offset: "25",
                                  "toggle-class": "header-dropdown-button",
                                  "menu-class": "header-dropdown-menu",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button-content",
                                      fn: function () {
                                        return [
                                          _c("img", {
                                            staticClass: "header-icon",
                                            attrs: {
                                              src: require("images/headerIcons/user.svg"),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "header-text mb-0 pl-2 mobile-hide",
                                              staticStyle: {
                                                "padding-right": "0.75rem",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    `${_vm.profile.surname} ${_vm.profile.name}`
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass: "ml-auto",
                                            attrs: {
                                              src: require("images/headerIcons/arrow.svg"),
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2235100681
                                ),
                              },
                              [
                                _vm._v(" "),
                                _vm.profile.type ===
                                _vm.$defines.ACCOUNT_TYPES.ADMIN
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        staticClass:
                                          "header-dropdown-item header-text item-substrate",
                                        attrs: { to: "/admin" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("button.adminPanel")
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    staticClass:
                                      "header-dropdown-item header-text item-substrate",
                                    attrs: { to: "/account" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("button.settings")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    staticClass:
                                      "header-dropdown-item header-text item-substrate",
                                    on: { click: _vm.logout },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("button.logout")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _c(
                      "router-link",
                      {
                        staticClass:
                          "header-link icon-substrate ml-auto mr-2 h-100",
                        staticStyle: {
                          color: "black",
                          height: "27px",
                          "border-radius": "5px",
                        },
                        attrs: { to: "/login" },
                      },
                      [
                        _c("img", {
                          staticClass: "header-icon",
                          attrs: {
                            src: require("images/headerIcons/login.svg"),
                          },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "header-text mb-0 pl-1" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("button.login")) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }